<template>
  <div class="chart-line-wrapper">
    <div ref="chartEl"></div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'

export default {
  name: 'ChartLine',
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 220,
    },
    colors: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      chart: null,
    }
  },
  mounted () {
    this.chart = new ApexCharts(this.$refs.chartEl, this.buildOptions())
    this.chart.render()
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  watch: {
    series (val) {
      if (this.chart) {
        this.chart.updateOptions({
          series: val,
          xaxis: { categories: this.categories },
        })
      }
    },
    categories (val) {
      if (this.chart) {
        this.chart.updateOptions({
          series: this.series,
          xaxis: { categories: val },
        })
      }
    },
  },
  methods: {
    buildOptions () {
      return {
        theme: { mode: 'dark' },
        chart: {
          type: 'area',
          height: this.height,
          background: 'transparent',
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        colors: this.colors.length ? this.colors : [this.$vuetify.theme.currentTheme.primary],
        stroke: { curve: 'smooth', width: 2 },
        fill: {
          type: 'gradient',
          gradient: { shadeIntensity: 1, opacityFrom: 0.25, opacityTo: 0.02 },
        },
        grid: {
          borderColor: '#2a2a3c',
          strokeDashArray: 4,
        },
        xaxis: {
          categories: this.categories,
          labels: { style: { colors: '#7C7C8A' } },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          labels: { style: { colors: '#7C7C8A' } },
        },
        dataLabels: { enabled: false },
        tooltip: { theme: 'dark' },
        noData: {
          text: 'Sem dados para exibir no período informado.',
          align: 'center',
          verticalAlign: 'middle',
          style: { color: '#C7C7D8', fontSize: '14px' },
        },
        series: this.series,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-line-wrapper {
  width: 100%;
}
</style>
